import placementsApi from "../../api/placements/opportunities";

export default {
  namespaced: true,

  state: {
    opportunities: [],
    internshipCourses: [],
    opportunityTypes: [],
    opportunityCategories: [],
    studentOpportunity: {
      studentOpportunityId: null,
      active: null,
      primarySelection: null
    },
    opportunity: {},
    additionalMaterialStatuses: [],
    opportunityFiles: [],
    reload: false,
    loading: []
  },

  mutations: {
    ADD_LOADING(state) {
      console.log("pushing request");
      state.loading.push(state.loading.length + 1);
    },
    REMOVE_LOADING(state) {
      console.log("popping loading");
      state.loading.pop();
    },
    SET_OPPORTUNITIES(state, payload) {
      console.log("Setting payload");
      state.opportunities = payload;
    },
    SET_INTERNSHIP_COURSES(state, payload) {
      console.log("Setting payload");
      state.internshipCourses = payload;
    },
    SET_OPPORTUNITY_TYPES(state, payload) {
      console.log("Setting payload");
      state.opportunityTypes = payload;
    },
    SET_OPPORTUNITY_CATEGORIES(state, payload) {
      console.log("Setting payload");
      state.opportunityCategories = payload;
    },
    SET_STUDENTOPPORTUNITY(state, payload) {
      state.studentOpportunity = payload;
    },
    SET_ADDITIONAL_MATERIAL_STATUSES(state, payload) {
      state.additionalMaterialStatuses = payload;
    },
    SET_OPPORTUNITY(state, payload) {
      state.opportunity = payload;
    },
    SET_OPPORTUNITY_FILES(state, payload) {
      state.opportunityFiles = payload;
    },
    TOGGLE_REFRESH(state) {
      console.log("Refresh requested");
      state.reload = !state.reload;
    }
  },

  actions: {
    toggleRefresh(context) {
      context.commit("TOGGLE_REFRESH");
    },
    getOpportunitiesForStudent(context, userId) {
      context.commit("ADD_LOADING");
      return placementsApi
        .getOpportunitiesForStudent(userId)
        .then(response => {
          console.log("received opps");
          context.commit("SET_OPPORTUNITIES", response.data);
          context.commit("REMOVE_LOADING");
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    getOpenOpportunitiesForStudent(context, userId) {
      return placementsApi
        .getOpenOpportunitiesForStudent(userId)
        .then(response => {
          console.log("received opps");
          context.commit("SET_OPPORTUNITIES", response.data);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    getInternshipCourses(context) {
      return placementsApi
        .getInternshipCourses()
        .then(response => {
          console.log("received terms");
          context.commit("SET_INTERNSHIP_COURSES", response.data);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    getOpportunityTypes(context) {
      return placementsApi
        .getOpportunityTypes()
        .then(response => {
          console.log("received types");
          context.commit("SET_OPPORTUNITY_TYPES", response.data);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    getOpportunityCategories(context) {
      return placementsApi
        .getOpportunityCategories()
        .then(response => {
          console.log("received categories");
          context.commit("SET_OPPORTUNITY_CATEGORIES", response.data);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    addOpportunity(context, config) {
      return new Promise((resolve, reject) => {
        placementsApi.postAddOpportunity(config.id, config.asuriteId).then(
          response => {
            context.commit("SET_STUDENTOPPORTUNITY", response.data);
            //context.commit("TOGGLE_REFRESH", true);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    removeOpportunity(context, config) {
      return placementsApi
        .postRemoveStudentOpportunity(
          config.studentOpportunityId,
          config.userId
        )
        .then(() => {
          console.log("removed opportunity " + config.studentOpportunityId);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          context.commit("TOGGLE_REFRESH", true);
        });
    },
    setPrimaryIntent(context, config) {
      return placementsApi
        .postSetPrimaryIntent(config.studentOpportunityId, config.userId)
        .then(() => {
          console.log("set as primary " + config.studentOpportunityId);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          context.commit("TOGGLE_REFRESH", true);
        });
    },
    getStudentOpportunity(context, studentOpportunityId) {
      return new Promise((resolve, reject) => {
        placementsApi.getStudentOpportunity(studentOpportunityId).then(
          response => {
            context.commit("SET_STUDENTOPPORTUNITY", response.data);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    getStudentOpportunityAdditionalMaterialStatuses(context) {
      return new Promise((resolve, reject) => {
        placementsApi.getStudentOpportunityAdditionalMaterialStatuses().then(
          response => {
            context.commit("SET_ADDITIONAL_MATERIAL_STATUSES", response.data);
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    getOpportunityForStudent(context, config) {
      return new Promise((resolve, reject) => {
        placementsApi
          .getOpportunityForStudent(config.opportunityId, config.asuriteId)
          .then(
            response => {
              context.commit("SET_OPPORTUNITY", response.data);
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    getOpportunityFiles(context, id) {
      return new Promise((resolve, reject) => {
        placementsApi.getOpportunityFiles(id).then(response => {
          context.commit("SET_OPPORTUNITY_FILES", response.data);
          resolve(response);
        }),
          error => {
            reject(error);
          };
      });
    },
    postSubmit(context, config) {
      return new Promise((resolve, reject) => {
        placementsApi.postSubmit(config.materialId).then(response => {
          context.commit("TOGGLE_REFRESH", true);
          resolve(response);
        }),
          error => {
            reject(error);
          };
      });
    },
    postFile(context, config) {
      return new Promise((resolve, reject) => {
        placementsApi
          .postFile(config.formData, config.fileList)
          .then(response => {
            context.commit("TOGGLE_REFRESH", true);
            resolve(response);
          }),
          error => {
            reject(error);
          };
      });
    },
    postInformationUpdate(context, config) {
      return new Promise((resolve, reject) => {
        placementsApi
          .postInformationUpdate(config.note)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    postInformationUpdateEmail(context, informationUpdateId) {
      return placementsApi
        .postInformationUpdateEmail(informationUpdateId)
        .catch(error => {
          console.log(error);
        });
    },
    postUpdateJobDetails(context, config) {
      return new Promise((resolve, reject) => {
        placementsApi
          .postUpdateJobDetails(config.studentOpportunity, config.asuriteId)
          .then(function(response) {
            //context.commit("SET_GOALS", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    generateAdditionalMaterialDocument(context, config) {
      return new Promise((resolve, reject) => {
        placementsApi
          .getGenerateAdditionalMaterialDocument(
            config.studentOpportunityAdditionalMaterialId
          )
          .then(response => {
            //context.commit("SET_OPPORTUNITY_FILES", response.data);
            resolve(response);
          }),
          error => {
            reject(error);
          };
      });
    },
    postStudentOpportunityContact(context, config) {
      return new Promise((resolve, reject) => {
        placementsApi
          .postStudentOpportunityContact(config.studentOpportunity)
          .then(response => {
            console.log(
              "posted student opportunity contact " +
                config.studentOpportunityContact
            );
            resolve(response);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            // do nothing
          });
      });
    },
    resetStudentOpportunity(context) {
      var emptyStudentOpportunity = {
        studentOpportunityId: null,
        active: null,
        primarySelection: null
      };
      context.commit("SET_STUDENTOPPORTUNITY", emptyStudentOpportunity);
    },
    sendILASubmissionEmail(context, studentOpportunityId) {
      return new Promise((resolve, reject) => {
        placementsApi
          .createILASubmissionEmail(studentOpportunityId)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
